import Authenticated from './AuthenticatedRoute';

export const AuthenticatedRoute = Authenticated;